export const DEFAULT_SPLIT_POINT = 'onboarding';
export const DEFAULT_SPLITTER_PROVIDER = 'internal';
export const DEFAULT_PLATFORM_TYPE = 'web';
export type FlowType = 'Email' | 'General flow';
export type SplitTrafficMode = 'onboarding' | 'payment';
export type SplitterProviderMode = 'internal' | 'eppo';
export type PlatformType = 'web' | 'android' | 'ios' | 'mobile';
export type ScreenFlowType = 'onboarding' | 'payment';
export const DESIGN_SYSTEM_TYPE = {
    LEGACY: 'legacy',
    STRIDE: 'stride',
} as const;

export type DesignSystemType = (typeof DESIGN_SYSTEM_TYPE)[keyof typeof DESIGN_SYSTEM_TYPE];

// Explicit per-flow override of a Stride brand's default light/dark color mode. Applies to the
// Stride screens in the flow — null/absent means "use the brand's runtime default"
// (see wellfunnel's getDSBrand.ts, BRAND_ID_TO_DEFAULT_COLOR_THEME).
export const COLOR_THEME = {
    LIGHT: 'light',
    DARK: 'dark',
} as const;

export type ColorThemeType = (typeof COLOR_THEME)[keyof typeof COLOR_THEME];
export const COLOR_THEMES: ColorThemeType[] = Object.values(COLOR_THEME);

export enum AppLinkPlatform {
    Ios = 'ios',
    Android = 'android',
}

export const FLOW_TYPES = ['onboarding', 'payment'];
export const CATEGORIES_TYPES = ['select', 'info', 'loaders', 'input', 'modals', 'payment_info', 'products', 'checkouts'];
export const DESIGN_SYSTEM_TYPES: DesignSystemType[] = Object.values(DESIGN_SYSTEM_TYPE);
export const QA_EMAILS = ['wellfunnel_aqa@welltech.com'];

export const platformTypes = [
    { name: 'Web', value: 'web' },
    { name: 'Android', value: 'android' },
    { name: 'iOS', value: 'ios' },
];

export const splitPoints = [
    { name: 'Onboarding', value: 'onboarding' },
    { name: 'Payment', value: 'payment' },
];

export const headerTypes = [
    { name: 'Off', value: 'off' },
    { name: 'Logo left', value: 'logo_left' },
    { name: 'Progress', value: 'progress' },
    { name: 'Sign in', value: 'sign_in' },
    { name: 'Skip', value: 'skip' },
    { name: 'Logo left on the plate', value: 'logo_left_plate' },
    { name: 'Logo centered', value: 'logo_centered' },
    { name: 'Progress redesign', value: 'progress_redesign' },
    { name: 'Logo left with burger menu', value: 'logo_left_burger' },
    { name: 'Progress with burger menu', value: 'progress_burger' },
    { name: 'Progress redesign with burger menu', value: 'progress_burger_redesign' },
];

export const productTag = [
    { name: 'Main', value: 'main' },
    { name: 'Offer', value: 'offer' },
    { name: 'Upsell', value: 'upsell' },
    { name: 'None', value: 'none' },
];
